import { api, apiEndPoints } from "../../../api";
import { showSnackbar } from "../../../components/snackbar/actions";
import { snackbarTypes } from "../../../constants";
import { clearFiles, setFiles } from "../../../utils/upload-file/actions";

const namespace = "containers/CMS/testimonials";

export const SET_TESTIMONIAL_LIST = `${namespace}/SET_TESTIMONIAL_LIST`;
export const SET_TESTIMONIAL_FILTER = `${namespace}/SET_TESTIMONIAL_FILTER`;
export const RESET_TESTIMONIAL_FILTER = `${namespace}/RESET_TESTIMONIAL_FILTER`;

export const setTestimonialsList = (payload) => ({
  type: SET_TESTIMONIAL_LIST,
  payload,
});

export const setTestimonilaFilter = (payload) => ({
  type: SET_TESTIMONIAL_FILTER,
  payload,
});

export const resetTestimonilaFilter = () => ({
  type: RESET_TESTIMONIAL_FILTER,
});

export const getTestimonialList = (params) => async (dispatch) => {
  try {
    const response = await api.get(apiEndPoints.getTestimonials, {
      params: { params },
    });
    const { data, data: { is_success } = {} } = response;
    if (is_success) {
      dispatch(setTestimonialsList(data));
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const addTestimonial = (payload) => async (dispatch) => {
  try {
    const response = await api.post(apiEndPoints.addTestimonial, payload);
    const { data: { is_success, message } = {} } = response;
    if (is_success) {
      dispatch(
        showSnackbar({
          message: message,
          type: snackbarTypes.SUCCESS,
        })
      );
      return true;
    }
    dispatch(
      showSnackbar({
        message: message,
        type: snackbarTypes.ERROR,
      })
    );
    return false;
  } catch (error) {
    return false;
  }
};

export const getTestimonial = (id) => async (dispatch) => {
  try {
    const response = await api.get(apiEndPoints.getSingleTestimonial(id));
    const { data: { is_success, testimonial, files } = {} } = response;
    if (is_success) {
      dispatch(clearFiles());
      if (files.length) {
        files.map((file) => {
          return dispatch(setFiles(file));
        });
      }
      return testimonial;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const editTestimonial = (payload, id) => async (dispatch) => {
  try {
    const response = await api.put(apiEndPoints.updateTestimonial(id), payload);
    const { data: { is_success, message } = {} } = response;
    if (is_success) {
      dispatch(
        showSnackbar({
          message: message,
          type: snackbarTypes.SUCCESS,
        })
      );
      return true;
    }
    dispatch(
      showSnackbar({
        message: message,
        type: snackbarTypes.ERROR,
      })
    );
    return false;
  } catch (error) {
    return false;
  }
};

export const deleteTestimonial = (id) => async (dispatch) => {
  try {
    const response = await api.delete(apiEndPoints.deleteTestimonial(id));
    const { data: { is_success, message } = {} } = response;
    if (is_success) {
      dispatch(
        showSnackbar({
          message: message,
          type: snackbarTypes.SUCCESS,
        })
      );
      return true;
    }
    dispatch(
      showSnackbar({
        message: message,
        type: snackbarTypes.ERROR,
      })
    );
    return false;
  } catch (error) {
    return false;
  }
};
